var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"result"},[_c('div',{staticClass:"p-2 cursor-pointer hover:bg-gray-100 hover:text-black text-sm rounded transition",class:{ 'bg-gray-100 text-black': _vm.isHighlighted },on:{"click":_vm.select}},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.displayed))])]},null,_vm.$props)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }